
import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator';
import BackIcon from '@components/icons/icon-back.svg';
import PlusIcon from '@components/icons/icon-plus.svg';
import CheckIcon from '@components/icons/icon-check.svg';
import { RawLocation } from 'vue-router';

export interface NavigationButton {
  text: string,
  location: RawLocation
}

@Component({
  name: 'AppHeader',
  components: {
    BackIcon,
    PlusIcon,
    CheckIcon
  }
})
export default class AppHeader extends Vue {
  @Prop()
  private title: string;

  @Prop()
  private back: NavigationButton;

  @Prop()
  private add: NavigationButton;

  @Prop({ default: false })
  private saveButton: boolean;

  @Prop({ default: false })
  private saveDisabled: boolean;

  private saveEvent() {
    this.$emit('save');
  }
}
